__turbopack_context__.v({
  "button": "_-module__geF4-q__button",
  "large": "_-module__geF4-q__large",
  "loader": "_-module__geF4-q__loader",
  "loading": "_-module__geF4-q__loading",
  "orangePill": "_-module__geF4-q__orangePill",
  "pill": "_-module__geF4-q__pill",
  "primary": "_-module__geF4-q__primary",
  "rounded": "_-module__geF4-q__rounded",
  "secondary": "_-module__geF4-q__secondary",
  "small": "_-module__geF4-q__small",
  "standard": "_-module__geF4-q__standard",
  "tertiary": "_-module__geF4-q__tertiary",
  "yellowPill": "_-module__geF4-q__yellowPill",
});
